// General
import "./limited-time-coin-purchase-dialog.scss";
import { useEffect, forwardRef } from "react";
// Services
import { useLazyGetVirtualCurrencyCoinBalanceQuery } from "../../../../services/data.service";
// Static Data
import routeConst from "../../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateLimitedTimeCoinPurchaseDialog } from "../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import useCustomNavigate from "../../../utility/custom-hooks/useCustomNavigate-hook";
import IconManager from "../../../utility/manager/icon-manager/icon-manager";
// Components
import CoinsList from "../../coins-list/coins-list";

const LimitedTimeCoinPurchaseDialog = () => {
  // API variables
  const [
    getCoins,
    {
      data: getCoinsData,
      error: getCoinsErrorData,
      isFetching: getCoinsFetching,
      isLoading: getCoinsLoading,
      isSuccess: getCoinsSuccess,
      isError: getCoinsError,
    },
  ] = useLazyGetVirtualCurrencyCoinBalanceQuery();

  // Redux variables
  const limitedTimeCoinPurchaseDialog = useSelector(
    (state) => state.dialog.limitedTimeCoinPurchaseDialog
  );
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();
  const getIcon = IconManager();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!limitedTimeCoinPurchaseDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-D5",
      },
    });

    getCoins();
  }, [limitedTimeCoinPurchaseDialog]);

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateLimitedTimeCoinPurchaseDialog(false));
    onNavigate(routeConst.live.path);
  };

  // Utility Functions
  const getFormattedCoins = (coins) => {
    if (coins >= 100000) {
      return `${(coins / 1000).toFixed(1)}K`;
    } else {
      return coins?.toLocaleString();
    }
  };

  return (
    <Dialog
      className="custom-bottom-sheet-dialog"
      fullScreen
      open={limitedTimeCoinPurchaseDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <div id="limited-time-coin-purchase-dialog">
        <div className="padding-container">
          <div className="header-container">
            <div className="left-container"></div>
            <div className="middle-container">
              <div className="livestream-launch-label">
                {t("shop.livestreaming_launch_sale")}
              </div>
              <div className="limited-time-label">
                {t("shop.limited_time_only")}
              </div>
            </div>
            <div className="right-container">
              <div className="close-icon-container" onClick={onCloseDialog}>
                <CloseIcon className="close-icon" />
              </div>
            </div>
          </div>

          <div className="coins-tab-container">
            <CoinsList />
          </div>

          <div className="bottom-container">
            <div className="balance-container">
              <div className="add-icon-container">
                {getIcon("liveAddCoinIcon", "add-icon")}
              </div>

              <div className="balance-label">{t("common.balance")}:</div>

              <div className="coin-icon-container">
                {getIcon("sbCoinIcon", "coin-icon")}
              </div>

              <div className="coin-value">
                {getFormattedCoins(getCoinsData?.data?.balance)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default LimitedTimeCoinPurchaseDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
